/**
 * useDisableAnimations.tsx
 */
import { appSelector } from '@shared/store/slices/app.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useLayoutEffect } from 'react';

// Toggle the global 'disable-animations' class on the root element to match
// the device's capabilities, before the browser paints.

export default function useDisableAnimations() {
  const {
    status: { disableAnimations },
  } = useAppSelector(appSelector);

  useLayoutEffect(() => {
    document
      .getElementById('root')
      ?.classList.toggle('disable-animations', disableAnimations);
  }, [disableAnimations]);
}
